import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvProcessTable.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import StaticTable from "../../moreCore/UI/StaticTable/StaticTable";
import { MainCatalogTypes } from "../_loadingHelpers/MainCatalogTypes";
import EntityStore from '../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import EvProcessEditor from './EvProcessEditor';
import { EvProcess, EvProcessGroup, ProcessTypes, RefBookingEvProcess, RefProjectEvProcess } from "./EvProcessTypes";
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import FloatingMenu from '../../moreCore/UI/Floating/Menu';
import GenericDialog from "../../moreCore/UI/GenericDialog/GenericDialog";
import SearchSelect from "../../moreCore/UI/SearchSelect/SearchSelect";
import EvProcessGroupEditor from '../MainCatalogsEditor/EvProcessGroup/EvProcessGroupEditor';
import { _TabEnabledMixin } from "../../moreCore/_loadingHelpers/Tabbing";
import { DateHelpers, FeatureHelpers } from "../../more/Helpers";
import { SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";

class EvProcessTable extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin, _TabEnabledMixin) {
    templateString: any = template;

    private type: ProcessTypes;
    private contextEntity: EvProcessGroup | RefProjectEvProcess | RefBookingEvProcess;

    private evProcessExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private tableContainer: HTMLDivElement;
    private evProcessTable: MdsLax<InstanceType<typeof StaticTable>>;
    private evProcessStore: MdsLax<InstanceType<typeof EntityStore<EvProcess>>>;

    private reloadPageButton: HTMLElement;

    private processMenuButton: HTMLButtonElement;

    constructor(type: ProcessTypes) {
        super(...(arguments as unknown as []));
        this.type = type;
    }

    tableRowLayout: StaticTable.RowConfig = {
        attributes: [
            "ev_process_name",
            "date_start",
            "date_end",
            "duration",
            "ref_alternative_time_text.description",
        ],
        colNamesInternal: [
            "ev_process_name",
            "date_start",
            "date_end",
            "duration",
            "ref_alternative_time_text.description",
        ],
        headings: [
            (this as any).translate("EvProcessGroupEditor_Heading_EvProcessName"),
            (this as any).translate("EvProcessGroupEditor_Heading_DateStart"),
            (this as any).translate("EvProcessGroupEditor_Heading_DateEnd"),
            (this as any).translate("EvProcessGroupEditor_Heading_Duration"),
            (this as any).translate("General_Label_AlternativeTimeText"),
        ],
        //alignmentsRow: ["left", "left", "right", "left", "left"],
        //alignmentsHeading: ["left", "left", "right", "left", "left"],
        colspans: [1, 1, 1, 1, 1],
        widths: ["25ch", "15ch", "15ch", "7ch", "15ch"],

    }

    tableLayout: StaticTable.Layout = {
        label: "evProcessTable",
        name: "evProcessTable",
        rows: [(this as any).tableRowLayout],
        enableQuicksearch: true,
        quickSearchProperties: ["ev_process_name"],
        
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<MainCatalogTypes.EvProcess_LoadData>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let index = cell.tableRow.rowGroup.rowIndex;

        switch (colName) {
            case "duration":
                let duration = cell.value ? cell.value : 0;
                
                let durationStr = DateHelpers.convertSeconds(duration * 60, false, false, false, true, false);
                node.innerHTML = durationStr;// + " min";
                return true;
        }

        return false;
    }

    private _customTableSortFunction(a, b): number {


        if (a && a.hasOwnProperty("date_start")) {
            var dateA = new Date(a["date_start"]);
        } else {
            console.error("Argument a hast no property of date_start");
            return;
        }

        if (b && b.hasOwnProperty("date_start")) {
            var dateB = new Date(b["date_start"]);
        } else {
            console.error("Argument b hast no property of date_start");
            return;
        }

        return dateA.getTime() - dateB.getTime();
    }

    private _onClickTableRow(e: StaticTable.StaticTableRow<EvProcess>): void {
        var entity = e.rowGroup.entity;

        this._openEditor(entity);
    }

    private _onClickEditBtn(e: StaticTable.StaticTableRowGroup<EvProcess>): void {
        var entity = e.entity;

        this._openEditor(entity);
    }

    private _openEditor(entity: EvProcess) {
        var editorForm = new EvProcessEditor(this.type);
        editorForm.setContextEntity(this.contextEntity);
        editorForm.setupForm(entity);
        editorForm.on("confirmed", lang.hitch(this, this._onFormConfirmed, editorForm, false));
    }

    private _onFormConfirmed(editorForm: MdsLax<InstanceType<typeof EvProcessEditor>>, isNew: boolean, data): void {
        if (data && (data.order === null || data.order === undefined)) data.order = this.evProcessTable.getData().length + 1;
        if (isNew) {
            this.evProcessStore.addEntry(data);
        } else {
            this.evProcessStore.changeEntry(data, true);
        }
        editorForm.close();
    }

    private _setupTable(): void {
        this.evProcessTable = new StaticTable();
        this.evProcessTable.addLayout(this.tableLayout);
        this.evProcessTable.addDefaultRowActionButton("delete");
        this.evProcessTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditBtn));
        this.evProcessTable.setRowClick(lang.hitch(this, this._onClickTableRow));
        this.evProcessTable.setFormatter(lang.hitch(this, this._tableFormatter));
        this.evProcessTable.setupFromStore(this.evProcessStore);
        this.evProcessTable.setupRowSorting("order", lang.hitch(this, this._onRowSorting));
        //this.evProcessTable.setCustomSortFunction(this._customTableSortFunction);
        this.evProcessTable.setCyAttribute("exProcessTable");

        this.evProcessTable.placeAt(this.evProcessExpander);
    }

    private _onRowSorting(rowGroup: StaticTable.StaticTableRowGroup<EvProcess>) {
        for (let entry of this.evProcessTable.getData()) {
            var copy = lang.clone(entry) as EvProcess;
            copy["order"] += 1;
            this.evProcessStore.changeEntry(copy, true);
        }
    }

    private _onChangeStore(): void {
        let completeList = this.evProcessStore.getCurrentCompleteList();
        this.evProcessExpander.setMarking(completeList?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        var evProcessDiffData = this.evProcessStore.getDiffData();
        this.emit("change", evProcessDiffData);
    }

    private _onClickEvProcessMenuButton(e): void {
        let floatingMenu = new FloatingMenu();
        let icon = null;

        let isDirty = this.evProcessStore.isDirty();

        floatingMenu.addEntry({
            callback: lang.hitch(this, this._onClickButtonEvProcessAdd),
            label: "EvProcess_Label_ManuelEntry",
            icon: "fas fa-plus-circle"
        });

        if (this.type != "template") {
            floatingMenu.addEntry({
                callback: lang.hitch(this, this._onClickTemplateEntry),
                label: "EvProcess_Label_TemplateEntry",
                icon: "fas fa-object-group"
            });

            if (this.type === "project") {
                floatingMenu.addEntry({
                    callback: lang.hitch(this, this._onClickBookingEntry),
                    label: "EvProcess_Label_BookingEntry",
                    icon: ""
                });
            }

            if (this.hasUserRole("MainCatalogsEditor_EvProcessGroup") && FeatureHelpers.hasFeature("MainCatalog/Process")) {
                floatingMenu.addEntry({
                    callback: lang.hitch(this, this._onClickCreateTemplateEntry),
                    label: "EvProcess_Label_CreateTemplateEntry",
                    groupname: "maincatalogs",
                    icon: "fas fa-edit"
                });
            }
        }


        floatingMenu.open(e, null, "General_label_EvProcesses");

    }

    private _onClickCreateTemplateEntry(e): void {
        let currentCompleteList = lang.clone(this.evProcessStore.getCurrentCompleteList());
        let groupEditor = new EvProcessGroupEditor();

        let data = {
            "EL_ev_process_event_process_group": lang.clone(currentCompleteList)
        }

        groupEditor.setProcesses(currentCompleteList);
        let newLabel = this.translate("General_CreateNew") + " - " + this.translate("General_Label_EvProcessGroup");
        groupEditor.updateHeading(newLabel);

        groupEditor.setStartupState("ready");

        if (this.getTabContainer()) {
            this.requestNewTabbedContent({
                enableClosing: true,
                widget: groupEditor,
                name: "newGroupEditor_" + Math.random() * 1000,
                label: newLabel,
                groupLabel: newLabel,
                targetContainerName: this.getTabContainerName()
            }, true);
        } else {
            //Create DLG
        }
    }

    private _showDirtyStoreToast(): void {
        this.showToast(this.translate("EvProcess_Warning_StoreDirty"), "fas fa-exclamation-triangle");
    }

    private _onClickTemplateEntry(e): void {
        if (this.evProcessStore.isDirty()) {
            this._showDirtyStoreToast();
            return;
        }

        //Set to false if regular dlg with static table in content is wanted (previous developement to SED preview)
        if (true) {
            this.openSelectEntityDialog(e, "selectTemplate", lang.hitch(this, this._onTemplateSEDResponse));
            return;
        }


        let templateDlg = new GenericDialog();
        let searchSelect = new SearchSelect();

        let staticTable = new StaticTable();
        staticTable.addLineConfig(this.tableRowLayout);
        staticTable.setCyAttribute("evProcessTable");

        searchSelect.valueAttribute = "ID";
        searchSelect.labelAttribute = "description";
        searchSelect.setCallfunction("Webtool_API__EvProcess_GetTemplates");
        searchSelect.loadListValues(null, true);
        searchSelect.setLabel(this.translate("General_Label_EvProcessGroup"));
        searchSelect.on("change", lang.hitch(this, this._onChangeTemplateSelect, searchSelect, staticTable));

        templateDlg.addWidgetToContent(searchSelect);
        templateDlg.addWidgetToContent(staticTable);
        templateDlg.enableContentOverflow(true);


        templateDlg.show(null,
            this.translate("EvProcess_Heading_SelectTemplateDlg"),
            null,
            null,
            "okcancel",
            lang.hitch(this,
                this._openPickTemplateDlgResponse,
                searchSelect
            )
        );

        //this.UiModder.domClass.add(staticTable.tableRoot, "w3-row-padding w3-section");
    }

    private _onTemplateSEDResponse(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<EvProcessGroup>>) {
        if (items && items.length === 1) {
            let template = items[0].entry.data;

            this.RequestManager.callfunction("Webtool_API__EvProcess_CreateFromTemplate", { evProcessGroup: template, contextEntity: this.contextEntity }, lang.hitch(this, this._onCreateFromTemplateResponse), lang.hitch(this, this._onCreateFromTemplateError), true);
        }
    } 

    private _onChangeTemplateSelect(select: MdsLax<InstanceType<typeof SearchSelect>>, table: MdsLax<InstanceType<typeof StaticTable>>) {
        let selectedEntity = select.getSelectedEntity()

        let processes = selectedEntity ? selectedEntity.EL_ev_process_event_process_group : [];
        table.setData(processes);
    }

    private _openPickTemplateDlgResponse(searchSelect: MdsLax<InstanceType<typeof SearchSelect>>, response: number): void {
        if (response === 1) {
            let template = searchSelect.getValue(true);
            this.RequestManager.callfunction("Webtool_API__EvProcess_CreateFromTemplate", { evProcessGroup: template, contextEntity: this.contextEntity }, lang.hitch(this, this._onCreateFromTemplateResponse), lang.hitch(this, this._onCreateFromTemplateError), true);
        }

    }

    private _onCreateFromTemplateResponse(response): void {
        this.reload();
    }

    private _onCreateFromTemplateError(error): void {
        console.error(error);
    }

    private _onClickBookingEntry(e): void {
        if (this.evProcessStore.isDirty()) {
            this._showDirtyStoreToast();
            return;
        }

        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__EvProcess_CreateFromBookings", { contextEntity: this.contextEntity, type: this.type }, lang.hitch(this, this._onCreateFromBookingsResponse), lang.hitch(this, this._onCreateFromBookingsError), true);
    }

    private _onCreateFromBookingsResponse(response): void {
        this.emit("reloaded");
        this.StandbyStop();
        this.reload();
    }

    private _onCreateFromBookingsError(error): void {
        console.error(error);
    }

    private _onClickButtonEvProcessAdd(e): void {
        var editorForm = new EvProcessEditor(this.type);
        editorForm.setContextEntity(this.contextEntity);

        switch (this.type) {
            case "template":
                editorForm.setTemplate(this.contextEntity);
                break;
            case "project":
                editorForm.setProject(this.contextEntity as RefProjectEvProcess);
                break;
            case "booking":
                editorForm.setBooking(this.contextEntity as RefBookingEvProcess);
                break;
        }

        editorForm.setupForm();

        editorForm.on("confirmed", lang.hitch(this, this._onFormConfirmed, editorForm, true));
    }



    private _onClickReloadButton(e): void {
        this.reload();
    }

    private setContextEntity(entity: EvProcessGroup | RefProjectEvProcess | RefBookingEvProcess) {
        this.contextEntity = entity;
        this.hideNode(this.reloadPageButton, false);
    }

    setData(data: Array<EvProcess>, contextEntity: EvProcessGroup | RefProjectEvProcess | RefBookingEvProcess) {
        if (data) {
            this.addOffsetToDates(data);
            this.evProcessStore.setup(data);
        }

        if(contextEntity) this.setContextEntity(contextEntity);

        this.evProcessExpander.setMarking(data?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);


    }

    private reload(): void {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__EvProcess_GetProcessData", { contextEntity: this.contextEntity, type: this.type }, lang.hitch(this, this._onRealoadResponse), lang.hitch(this, this._onReloadError));
    }

    private _onRealoadResponse(response: Array<EvProcess>): void {
        this.evProcessStore.reset();
        this.setData(response, this.contextEntity);
        this.StandbyStop();
        this.emit("reloaded");
    }

    private _onReloadError(error): void {
        console.error(error);
    }

    private _handleVisibility() {
        this.hideNode(this.processMenuButton, !(this.type === "project" || this.type === "booking"));
    }

    private addOffsetToDates(processArray: Array<EvProcess>) {
        for (let process of processArray) {
            if (process.date_start) process.date_start_offset = -process.date_start.getTimezoneOffset();
            if (process.date_end) process.date_end_offset = -process.date_end.getTimezoneOffset();
        }
    }

    setProcesses(processArray: Array<EvProcess>) {
        this.addOffsetToDates(processArray);
        this.evProcessStore.addEntries(processArray);


    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.hideNode(this.reloadPageButton, true);

        this.evProcessStore = new EntityStore();
        this.evProcessStore.on("change", lang.hitch(this, this._onChangeStore));
        this._setupTable();

        this.SEDconfigCallfunction = "Webtool_API__EvProcess_GetSEDConfig";

        //this._handleVisibility();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvProcessTable);